exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-error[data-v-88836f92] .multi-select-input{border-color:#dc3545}.has-error[data-v-88836f92] .multi-select-input.multi-select-input-focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}", ""]);

// exports
